<div class="contract-renewal-dialog-plugin" hive-root>
    <!-- Dialog header -->
    <header class="contract-renewal-dialog-plugin__header">
        <hive-label
            label="{{ renderInfo().recommendationHeaderLabel }} Recommendation for {{ renderInfo().targetName }} {{
                renderInfo().subHeaderLabel
            }}"
            size="medium"
            weight="semibold"
        ></hive-label>
    </header>

    <!-- Dialog body -->
    <main class="contract-renewal-dialog-plugin__body">
        <!-- Main Recommendation content -->
        <section class="contract-renewal-dialog-plugin__contract">
            <div class="contract-renewal-dialog-plugin__contract-header">
                <img src="images/rec-contract-renewal-icon.svg" alt="Contract renewal icon" />
                <hive-label
                    label="{{ renderInfo().recommendationHeaderLabel }} for {{ renderInfo().targetName }} {{
                        renderInfo().subHeaderLabel
                    }}"
                ></hive-label>
            </div>
            <div class="contract-renewal-dialog-plugin__contract-details">
                <div class="contract-renewal-dialog-plugin__expiry">
                    @if (renderInfo().contractTargets && renderInfo().contractTargets.length > 0) {
                        <hive-table [value]="paginatedContractTargets()" [scrollable]="true" scrollHeight="300px">
                            <ng-template hiveTemplate="toolbar">
                                <hive-pagination
                                    [itemsPerPage]="pageSize()"
                                    [offset]="offset()"
                                    [totalItemCount]="renderInfo().contractTargets.length"
                                    [pageSizeDropdownVisible]="true"
                                    [itemsPerPageOptions]="PAGE_SIZE_OPTIONS"
                                    (pageChange)="onPageChange($event)"
                                    (itemsPerPageChange)="onItemsPerPageChange($event)"
                                ></hive-pagination>
                            </ng-template>
                            <ng-template hiveTemplate="header">
                                <tr>
                                    <th hive-header id="applianceName" primaryText="Appliance Name"></th>
                                    <th hive-header id="model" primaryText="Model"></th>
                                    <th hive-header id="subscriptionType" primaryText="Subscription Type"></th>
                                    <th hive-header id="expiryRemainingDays" primaryText="Expires In"></th>
                                </tr>
                            </ng-template>
                            <ng-template hiveTemplate="body" let-target>
                                <tr>
                                    <td hive-cell [primaryText]="target.applianceName"></td>
                                    <td hive-cell [primaryText]="target.model"></td>
                                    <td hive-cell [primaryText]="target.subscriptionType"></td>
                                    <td hive-cell [primaryText]="target.expiryRemainingDays"></td>
                                </tr>
                            </ng-template>
                        </hive-table>
                    }
                </div>
            </div>
        </section>

        <!-- Add-ons -->
        @if (renderInfo().addOns && renderInfo().addOns.length > 0) {
            @for (addOn of renderInfo().addOns; track addOn) {
                <section class="contract-renewal-dialog-plugin__addon">
                    <div class="contract-renewal-dialog-plugin__addon-header">
                        <img src="{{ addOn.iconUrl }}" alt="{{ addOn.header }} icon" />
                        <div class="contract-renewal-dialog-plugin__addon-info">
                            <hive-label [label]="addOn.header"></hive-label>
                            <hive-label
                                class="contract-renewal-dialog-plugin__addon-subtitle"
                                [label]="addOn.subheader"
                                size="smallest"
                            ></hive-label>
                        </div>
                        <div class="contract-renewal-dialog-plugin__addon-actions">
                            <hive-label [label]="addOn.priceTagPerYear" weight="semibold"></hive-label>
                            <hive-button [icon]="faPlus" label="Add" emphasis="tertiary"></hive-button>
                        </div>
                    </div>
                </section>
            }
        }
    </main>

    <!-- Dialog footer -->
    <footer class="contract-renewal-dialog-plugin__footer">
        <div class="contract-renewal-dialog-plugin__footer-left">
            <hive-button
                label="Cancel"
                emphasis="tertiary"
                (click)="handleActionEvent(RecommendationActionEvent.CANCEL)"
            ></hive-button>
        </div>
        <div class="contract-renewal-dialog-plugin__footer-right">
            @if (renderInfo().priceTag) {
                <hive-label label="Total: {{ renderInfo().priceTag }}" weight="semibold"></hive-label>
            }
            <hive-button
                [icon]="faDownload"
                label="Download Quote"
                emphasis="primary"
                [disabled]="!renderInfo().allowQuoteDownload()"
                hiveTooltip
                [hiveTooltipDescription]="renderInfo().allowQuoteDownload() ? '' : 'Operation not permitted'"
                (click)="handleActionEvent(RecommendationActionEvent.DOWNLOAD_QUOTE)"
            ></hive-button>
            <hive-button
                [icon]="faUpload"
                label="Upload PO"
                emphasis="primary"
                [disabled]="!renderInfo().allowPurchaseOrderUpload()"
                hiveTooltip
                [hiveTooltipDescription]="renderInfo().allowPurchaseOrderUpload() ? '' : 'Operation not permitted'"
                (click)="handleActionEvent(RecommendationActionEvent.UPLOAD_PO)"
            ></hive-button>
            @if (renderInfo().allowDismiss || renderInfo().allowEmailQuote) {
                <hive-menu>
                    <hive-button hiveMenuButton [icon]="faEllipsisV" emphasis="secondary" caret="false" />
                    <hive-menu-item
                        label="Send Quote via Email"
                        [disabled]="!renderInfo().allowEmailQuote()"
                        hiveTooltip
                        [hiveTooltipDescription]="renderInfo().allowEmailQuote() ? '' : 'Operation not permitted'"
                        (click)="handleActionEvent(RecommendationActionEvent.REQUEST_QUOTE_BY_EMAIL)"
                    ></hive-menu-item>
                    <hive-menu-item
                        label="Dismiss Recommendation"
                        [disabled]="!renderInfo().allowDismiss()"
                        hiveTooltip
                        [hiveTooltipDescription]="renderInfo().allowDismiss() ? '' : 'Operation not permitted'"
                        (menuItemClick)="handleActionEvent(RecommendationActionEvent.DISMISS)"
                    ></hive-menu-item>
                </hive-menu>
            }
        </div>
    </footer>
</div>
